/**
 * Entwürfe, die in diesem Tab über die Auftragsart-Auswahl neu angelegt wurden.
 * Nur diese darf `LeerenEntwurfVerwerfenListener` beim Verlassen der Strecke löschen — ein über
 * die Übersicht/Deep-Link wieder geöffneter Entwurf ist nie enthalten. Bewusst flüchtig: nach
 * einem Reload ist die Menge leer, dann wird nichts gelöscht (im Zweifel erhalten).
 */
const frischeEntwuerfe = new Set<string>();

/** Markiert `auftragId` als in diesem Durchlauf frisch angelegten Entwurf. */
export function markiereFrischenEntwurf(auftragId: string): void {
  frischeEntwuerfe.add(auftragId);
}

/** `true`, wenn `auftragId` als frisch angelegter Entwurf markiert ist. */
export function istFrischerEntwurf(auftragId: string): boolean {
  return frischeEntwuerfe.has(auftragId);
}

/** Entfernt die Markierung für `auftragId`, z.B. sobald der Entwurf Mindestangaben erreicht hat. */
export function vergissFrischenEntwurf(auftragId: string): void {
  frischeEntwuerfe.delete(auftragId);
}

/** Nur für Tests. */
export function resetFrischeEntwuerfe(): void {
  frischeEntwuerfe.clear();
}
